import StyleSheet from 'react-native-extended-stylesheet';

export const styles = StyleSheet.create({
  layout: {
    height: '100vh',
    backgroundColor: '$colorBgBase',
  },
  container: {
    height: '100%',
  },
  header: {
    backgroundColor: '$colorBgBase',
    position: 'fixed',
    width: 'auto',
    zIndex: '$elevationLayerXS',
  },
  content: {
    flex: 1,
    maxWidth: 427,
    minHeight: 270,
  },
});
